import React from 'react';
import './BudgetYourTrip.css';
import { useState, useEffect } from 'react';


function BudgetYourTripB(props) {
    const [selectedValue, setSelectedValue] = useState("");
    const [travelStyle, setTravelStyle] = useState("midrange");
    const [currency, setCurrency] = useState("USD");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        resetForm();
    }, []);

    const resetForm = () => {
        setSelectedValue('');
    };

    // We select a different country
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        const selectedIndex = event.target.selectedIndex;
        const selectedOption = event.target.options[selectedIndex].textContent;
        props.onCountryChange(selectedOption);
    };
    const handleTravelStyle = (evt) => { setTravelStyle(evt.target.value); }
    const handleCurrency = (evt) => { setCurrency(evt.target.value); }

    // Find Country based on selection
    const linkToFind = selectedValue;
    let country = null;
    let externalLink = null;
    for (let i = 0; i < props.selectLabels.length; i++) {
        if (props.selectLabels[i].link === linkToFind) {
            country = props.selectLabels[i].country;
            break;
        }
    }
    if (country) {
        externalLink = 'https://www.budgetyourtrip.com/' + country.toLowerCase().replace(/\s/g, '-');
    }
    //console.log(externalLink);

    useEffect(() => {
        try {
            const widgetUrl = `https://widget.budgetyourtrip.com/location-widget-js/${selectedValue}&defaultcurrency=${currency}&defaultbudgetstyle=${travelStyle}`;
            const widgetContainer = document.getElementById("widget-container");
            // remove previous script element if it exists
            if (isLoading === false) {
                while (widgetContainer.firstChild) {
                    widgetContainer.removeChild(widgetContainer.firstChild);
                }
            }

            setIsLoading(true);

            const script = document.createElement("script");
            script.src = widgetUrl;
            script.async = true;

            widgetContainer.appendChild(script);

            script.onload = () => {
                setIsLoading(false);
                props.onWidgetLoaded();
            }

            return () => {
                widgetContainer.removeChild(script);
            };
        } catch (error) {
            console.error(error);
        }
    }, [selectedValue, travelStyle, currency]);

    // Create an array of options based on the data
    const options = props.selectLabels.map((item, idx) => (
        <option key={idx} value={item.link}>
            {`${item.country}`}
        </option>
    ));
    options.unshift(<option key="-1" value="">Select a country</option>);

    const loaderWrapperstyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        overflow: 'hidden',
        backgroundColor: 'var(--cl-blue--100)',
    };

    const spinnerStyles = {
        spinner: {
            borderTop: "5px solid #0080ff",
            borderRight: "5px solid transparent",
            borderBottom: "5px solid transparent",
            borderLeft: "5px solid transparent",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            animation: "spin 1s linear infinite",
            marginRight: "5px",
        },
        "@keyframes spin": {
            "0%": {
                transform: "rotate(0deg)",
            },
            "100%": {
                transform: "rotate(360deg)",
            },
        },
    };

    return (
        <div className="widget-container">
            {isLoading ? (
                <div className='loader-wrapper' style={loaderWrapperstyles}>
                    <div className='spinner' style={spinnerStyles}></div>
                    <p className="text-center text-gray-250 text-xl font-semibold">Loading...</p>
                </div>
            ) : ''}
            <header className='section-container'>
                <h2>Where are you going?</h2>
                <p>Choose your destination from the dropdown menu to see average costs for your travel budget and style</p>
            </header>
            <div className="fields-container">
                <div className="fields-container-inner">
                    <label
                        htmlFor="select-coutnry"
                        className='widget-field-label'
                    >Select a country</label>
                    <select
                        id="select-coutnry"
                        value={selectedValue}
                        onChange={handleChange}
                        className='widget-select-options'
                    >
                        {options}
                    </select>
                </div>
                <div className="fields-container-inner">
                    <label
                        htmlFor="travelStyle"
                        className='widget-field-label'
                    >Travel Style</label>
                    <select
                        id="travelStyle"
                        name="travelStyle"
                        className='widget-select-options'
                        onChange={handleTravelStyle}
                    >
                        <option value="midrange">Mid-Range</option>
                        <option value="budget">Budget (Cheap)</option>
                        <option value="luxury">Luxury (High-End)</option>
                    </select>
                </div>
                <div className="fields-container-inner">
                    <label
                        htmlFor="currency"
                        className='widget-field-label'
                    >Currency</label>
                    <select
                        id="currency"
                        name="curreny"
                        className='widget-select-options'
                        onChange={handleCurrency}
                    >
                        <option value="USD">Dollar (United States)</option>
                        <option value="EUR">Euro</option>
                        <option value="GBP">Pound Sterling (UK)</option>
                        <option value="AUD">Dollar (Australia)</option>
                    </select>
                </div>
            </div>
            <div id="widget-container">
                {isLoading && <p>Loading...</p>}
            </div>
            {country && !isLoading ? (<a
                className="budgetyourtrip-logo-pushdown text-blue-500"
                href={externalLink}
                rel="noreferrer"
                target="_blank">{country} Travel Costs</a>) : ''
            }
            {selectedValue && !isLoading ? (<p className='section-container'>The form below is filled with these numbers from Budgetyourtrip.com, based on the country and travel style you choose. Their numbers tend to be very reliable, in my experience.</p>) : ''}
        </div>
    );
};

export default BudgetYourTripB